<template>
  <b-row class="mb-3">
    <b-col md="6" class="my-1">
      <b-form-group horizontal label="Per page" class="mb-0">
        <b-form-select
          :id="'ddl-per-page_'+tableId" :options="pageOptions" v-model="perPage"
          @input="perPageChanged"
          aria-label="Choose to show between 10, 50, or 100 groups">
        </b-form-select>
      </b-form-group>
    </b-col>
    <b-col md="6" class="my-1">
      <b-form-group horizontal label="Filter" class="mb-0">
        <b-input-group>
          <b-form-input :id="'inp-filter_'+tableId"
                        v-model="filter"
                        @input="filterChanged"
                        placeholder="Type to Search"
                        aria-label="Type to search">
          </b-form-input>
          <b-input-group-append>
            <b-btn :id="'btn-clear-filter_'+tableId"
                   :disabled="!filter"
                   @click="resetFilter">
              Clear
            </b-btn>
          </b-input-group-append>
        </b-input-group>
      </b-form-group>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'TableOptionsFilter',
  props: {
    tableId: {
      type: String,
      required: true,
    },
    perPage: {
      type: Number,
      required: false,
      default: 10,
    },
    pageOptions: {
      type: Array,
      required: false,
      default() {
        return [10, 50, 100];
      },
    },
  },
  data() {
    return {
      filter: '',
    };
  },
  methods: {
    resetFilter() {
      this.filter = '';
      this.filterChanged(this.filter);
    },
    perPageChanged(value) {
      this.$emit('perPageChanged', value, this.tableId);
    },
    filterChanged(value) {
      this.$emit('filterChanged', value, this.tableId);
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/table/TableOptionsFilter.vue